module.exports = "/searche9cd6b44215b667155a9b2f28f87d189.svg";